import { SVGProps, Ref, forwardRef } from 'react';

export const SkillazBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.764.088a.64.64 0 0 1 .67.013l2.981 1.917a.64.64 0 0 1-.048 1.103l-6.07 3.194c-.19.1-.419.098-.607-.007L4.815 4.711A.639.639 0 0 1 4.8 3.602zM6.41 4.136l1.597.888L12.802 2.5 11.073 1.39z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.84 7.415a.64.64 0 0 1 .595.013L8.31 9.025a.639.639 0 0 1 0 1.117l-2.875 1.597a.64.64 0 0 1-.596.013l-3.194-1.597a.639.639 0 0 1 0-1.143zM3.36 9.583l1.75.875 1.575-.875-1.576-.875z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.595 9.04a.64.64 0 0 1 .621-.028l3.195 1.597c.216.108.353.33.353.572v3.513a.64.64 0 0 1-.94.564L1.63 13.554a.64.64 0 0 1-.338-.563V9.583c0-.221.114-.427.303-.543m.975 1.577v1.99l1.916 1.023v-2.055z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.8 3.602a.64.64 0 0 1 .635-.008L8.31 5.192a.64.64 0 0 1 .329.558v3.833a.64.64 0 0 1-.95.559L4.816 8.545a.64.64 0 0 1-.329-.559V4.153c0-.227.12-.436.315-.55m.964 1.637V7.61l1.597.888V6.126z"
            fill="#F7D044"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4 2.009a.64.64 0 0 1 .308.547v3.468a.64.64 0 0 1-.317.552l-2.664 1.55v3.1a.64.64 0 0 1-.318.552l-5.963 3.469a.639.639 0 0 1-.96-.553v-3.468c0-.229.123-.44.322-.555l2.553-1.458V5.75c0-.237.132-.455.342-.565l6.069-3.195a.64.64 0 0 1 .628.019M8.639 6.136v3.447c0 .23-.123.441-.322.555l-2.553 1.459v1.987l4.685-2.725V7.758c0-.227.121-.438.318-.552l2.664-1.55V3.614z"
            fill="#F7D044"
        />
    </svg>
));
SkillazBrandSize16Glyph.displayName = 'SkillazBrandSize16Glyph';
